export const mapCartItemToOrderDetails = (item) => ({
    ...item,
    thumbnail: item?.itemThumbnails?.[0],
    product: item.orderType,
    isFlatRate: item.selections.isFlatRate,
    itemTotals: item.itemTotals.filter((total)=>total.type==='subTotal'),
    shipping: null,
    scheduledDate: item.selections.futureFulfillment? {date: item.selections.scheduledDate}: null,
});
